// ----------------------------------------------------------------------
export var Popover = function Popover(_ref) {
  var theme = _ref.theme;
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: theme.shadows[25].z12
        }
      }
    }
  };
};